/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, memo } from "react";
import Cookies from "universal-cookie";
import queryString from "query-string";
import unorm from "unorm";

import CurrencyBox from "../components/CurrencyBox/CurrencyBox";
import CitySelector from "../components/CitySelector/CitySelector";

import * as priceHelper from "../helpers/price";
import * as SpeciesType from "../assets/js/SpeciesType";

import api from "../services/api";

function Main({ match, location }) {
  //svg
  const svgHideTax =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0idnVlc2F4X2xpbmVhcl9taW51cy1jaXJsY2UiIGRhdGEtbmFtZT0idnVlc2F4L2xpbmVhci9taW51cy1jaXJsY2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzIgLTI1MikiPgogICAgPGcgaWQ9Im1pbnVzLWNpcmxjZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcyIDI1MikiPgogICAgICA8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNi42NjcsMTMuMzMzQTYuNjY3LDYuNjY3LDAsMSwwLDAsNi42NjcsNi42ODYsNi42ODYsMCwwLDAsNi42NjcsMTMuMzMzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4yOCAxLjMzMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwYTZkYSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPHBhdGggaWQ9IlZlY3Rvci0yIiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMEg1LjMzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4yOCA4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBhNmRhIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8cGF0aCBpZD0iVmVjdG9yLTMiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwSDE2VjE2SDBaIiBmaWxsPSJub25lIiBvcGFjaXR5PSIwIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
  const svgShowTax =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0idnVlc2F4X2xpbmVhcl9taW51cy1jaXJsY2UiIGRhdGEtbmFtZT0idnVlc2F4L2xpbmVhci9taW51cy1jaXJsY2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzIgLTI1MikiPgogICAgPGcgaWQ9Im1pbnVzLWNpcmxjZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcyIDI1MikiPgogICAgICA8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNi42NjcsMTMuMzMzQTYuNjY3LDYuNjY3LDAsMSwwLDAsNi42NjcsNi42ODYsNi42ODYsMCwwLDAsNi42NjcsMTMuMzMzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4yOCAxLjMzMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwYTZkYSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPHBhdGggaWQ9IlZlY3Rvci0yIiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMEg1LjMzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4yOCA4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBhNmRhIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8cGF0aCBpZD0iVmVjdG9yLTMiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwSDUuMzMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3Ljk0NyAxMC42NjcpIHJvdGF0ZSgtOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICAgIDxwYXRoIGlkPSJWZWN0b3ItNCIgZGF0YS1uYW1lPSJWZWN0b3IiIGQ9Ik0wLDBIMTZWMTZIMFoiIGZpbGw9Im5vbmUiIG9wYWNpdHk9IjAiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
  const svgTrocaOrdem =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICA8ZyBpZD0iRXhjaGFuZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMjkyIDMyNzgpIj4KICAgIDxnIGlkPSJhcnJvdy0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE1ODggLTM0NjIpIj4KICAgICAgPGcgaWQ9Ikdyb3VwIj4KICAgICAgICA8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNy40NCwzLjcyLDMuNzIsMCwwLDMuNzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwMy4wMSAxOTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgICAgICA8cGF0aCBpZD0iVmVjdG9yLTIiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwxOFYwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDYuNzMgMTkxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBhNmRhIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICAgICAgPHBhdGggaWQ9IlZlY3Rvci0zIiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMCwzLjcyLDMuNzIsNy40NCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMTMuNTUgMjA1LjI4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBhNmRhIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICAgICAgPHBhdGggaWQ9IlZlY3Rvci00IiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMFYxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzE3LjI3IDE5MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwYTZkYSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgICA8L2c+CiAgICAgIDxwYXRoIGlkPSJWZWN0b3ItNSIgZGF0YS1uYW1lPSJWZWN0b3IiIGQ9Ik0wLDBIMjRWMjRIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwMCAxODgpIiBmaWxsPSJub25lIiBvcGFjaXR5PSIwIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iRWxpcHNlXzM3MiIgZGF0YS1uYW1lPSJFbGlwc2UgMzcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEyOTIgLTMyNzgpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNS4yNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

  const queryParams = queryString.parse(location.search);
  const cookies = new Cookies();
  const myCurrency = cookies.get("minha_moeda");
  const defaultCityCookie = cookies.get("defaultCity");
  const defaultCurrency = [{ codigo_iso: "BRL", simbolo: "R$" }];
  const [sourceAmount, setSourceAmount] = useState("1000,00");
  const [targetAmount, setTargetAmount] = useState("0");
  const [IOF, setIOF] = useState(0);
  const [currencies, setCurrencies] = useState([]);
  const [showHideTax, setShowHideTax] = useState(true);
  const [trocarOrdem, setTrocarOrdem] = useState(true);
  const [currentCurrency, setCurrentCurrency] = useState({ codigo_iso: "USD" });
  const prevCurrency = usePrevious(currentCurrency);
  const [currentQuotation, setCurrentQuotation] = useState({
    venda: {
      valor: 0,
      iof: 0,
      taxa: 0,
    },
    compra: {
      valor: 0,
      iof: 0,
      taxa: 0,
    },
    isLoading: true,
  });

  const [citySeletor, setCitySeletor] = useState(false);
  const [currentCity, setCurrentCity] = useState(null);
  const [showModalTaxas, setShowModalTaxas] = useState(false);
  const [productSpeciesType, setProductSpeciesType] = useState(SpeciesType.BUY);

  function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  }

  async function getDefaultCity(oldDefaultCityCookie = false) {
    try {
      const response = await api.get(`/v1/cidades?cidade=S%C3%A3o%20Paulo`);

      if (
        !currentCity ||
        (response.data.payload[0].id !== currentCity.id &&
          (!oldDefaultCityCookie ||
            oldDefaultCityCookie.id !== response.data.payload[0].id))
      ) {
        const nextYear = new Date();
        nextYear.setFullYear(new Date().getFullYear() + 1);
        cookies.set("defaultCity", response.data.payload[0], {
          path: "/",
          expires: nextYear,
        });
        setCurrentCity(response.data.payload[0]);
      } else {
        setCurrentQuotation({
          venda: {
            valor: 0,
            iof: 0,
            taxa: 0,
          },
          compra: {
            valor: 0,
            iof: 0,
            taxa: 0,
          },
          unavailable: true,
          isLoading: false,
        });
        return;
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (cookieIsValid(defaultCityCookie)) {
      setCurrentCity(defaultCityCookie);
    } else {
      getDefaultCity();
    }
  }, []);

  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const selectedProduct =
    match.params.produto != null ? match.params.produto : "especie";

  /**
   * USO EXCLUSIVO REMESSA
   */
  const [countries, setCountries] = useState(false);
  const [currentCountry, setCurrentCountry] = useState({
    codigo_iso_bacen: "US",
    nome: "ESTADOS UNIDOS",
  });

  useEffect(() => {
    async function getCountries() {
      try {
        const response = await api.get(`/v1/paises`);
        const payload = response.data.payload.filter((item) => {
          return item.nome !== "OUTROS";
        });

        const itemRemovido = payload.splice(3, 1);
        payload.splice(4, 0, itemRemovido[0]);

        setCountries(payload);
        setCurrentCountry(response.data.payload[0]);
      } catch (error) {}
    }

    if (selectedProduct === "remessa") getCountries();
  }, [selectedProduct]);
  /**
   * FIM USO REMESSA
   */

  useEffect(() => {
    setCurrentCurrency({});
    async function getCurrencies() {
      try {
        let url = `/v1/moedas-operacionais?tipo=${capitalize(
          selectedProduct
        )}&operacao=${inverseProductSpeciesType()}`;

        if (selectedProduct === "remessa")
          url += `&pais-id=` + currentCountry.id;

        const response = await api.get(url);
        let payload = response.data.payload;

        if (selectedProduct === "cartao") {
          payload = payload.filter((item) => {
            return item.tipo_cartao.nome === "ConfidenceMultiMoedaPlatinum";
          });
        }

        let currenciesSelected = payload.map((item) => {
          item.moeda.id_operacional = item.id;
          item.moeda.validacoes = {
            maximo_operavel: item.maximo_operavel,
            minimo_operavel: item.minimo_operavel,
            multiplicidade: item.multiplicidade,
          };

          return item.moeda;
        });

        setCurrencies(currenciesSelected);

        let selectedCurrency = currenciesSelected[0];
        if (cookieIsValid(myCurrency)) {
          let myCurrencyData = currenciesSelected.filter((currency) => {
            return currency.codigo_iso === myCurrency;
          });

          if (myCurrencyData.length) {
            selectedCurrency = myCurrencyData[0];
          }
        }

        if (queryParams.moeda != null) {
          let currencyFromQuery = currenciesSelected.filter((currency) => {
            return currency.codigo_iso === queryParams.moeda;
          });

          if (currencyFromQuery.length) {
            selectedCurrency = currencyFromQuery[0];
          }
        }

        setCurrentCurrency(selectedCurrency);
      } catch (error) {}
    }

    if (currentCity) {
      if (selectedProduct !== "remessa") {
        getCurrencies();
      } else {
        if (Object.keys(currentCountry).length > 0 && currentCountry.id)
          getCurrencies();
      }
    }
  }, [
    currentCity,
    selectedProduct,
    productSpeciesType,
    currentCountry,
    queryParams.moeda,
  ]);

  useEffect(() => {
    setCurrentQuotation({
      venda: {
        valor: 0,
        iof: 0,
        taxa: 0,
      },
      compra: {
        valor: 0,
        iof: 0,
        taxa: 0,
      },
      isLoading: true,
    });

    async function getCurrencyQuotation() {
      try {
        const api_version = selectedProduct === "especie" ? "v2" : "v1";
        const response = await api.get(
          `/${api_version}/moedas-operacionais/${currentCurrency.id_operacional}/cotacao?cidade-id=${currentCity.id}`
        );

        const nextYear = new Date();
        nextYear.setFullYear(new Date().getFullYear() + 1);
        cookies.set("defaultCity", currentCity, {
          path: "/",
          expires: nextYear,
        });
        cookies.set("minha_moeda", currentCurrency.codigo_iso, {
          path: "/",
          expires: nextYear,
        });

        if (isProductSpeciesSell()) {
          const cotacao = (
            await api.post("/v1/cotacoes/arredondamento", {
              cotacao: response.data.payload.compra.valor,
              iof: response.data.payload.compra.iof,
              moeda: currentCurrency.id_operacional,
              quantidade: priceHelper.priceToFloat(sourceAmount),
              taxa: response.data.payload.compra.taxa,
            })
          ).data.payload.cotacao;
          response.data.payload.compra.valor = cotacao;
        }

        setCurrentQuotation(response.data.payload);
      } catch (error) {
        if (
          currentCurrency !== prevCurrency &&
          Object.keys(prevCurrency).length > 0
        ) {
          setCurrentCurrency(prevCurrency);
          if (window.parent.toastError) {
            window.parent.toastError(
              "Moeda indisponível na região. Favor selecionar outra cidade."
            );
          }
          return;
        }

        if (currentCity.id === defaultCityCookie.id) {
          const oldDefaultCityCookie = cookies.get("defaultCity");
          cookies.remove("defaultCity");
          getDefaultCity(oldDefaultCityCookie);
        } else {
          setCurrentCity(cookies.get("defaultCity"));
        }

        if (window.parent.toastError) {
          window.parent.toastError(
            "Moeda indisponível na região. Favor selecionar outra cidade."
          );
        }
      }
    }

    if (currentCurrency.id_operacional) getCurrencyQuotation();
  }, [currentCurrency, selectedProduct, productSpeciesType]);

  useEffect(() => {
    if (Object.keys(currentQuotation).length > 0) {
      calcTargetAmount();
    }
  }, [currentQuotation, sourceAmount]);

  async function calcTargetAmount() {
    let {
      valor: value,
      iof: iofPorcentage,
      taxa: tax,
    } = currentQuotation[inverseProductSpeciesTypeLowerCase()];

    if (isProductSpeciesSell() && value) {
      const cotacao = (
        await api.post("/v1/cotacoes/arredondamento", {
          cotacao: value,
          iof: iofPorcentage,
          moeda: currentCurrency.id_operacional,
          quantidade: priceHelper.priceToFloat(sourceAmount),
          taxa: tax,
        })
      ).data.payload.cotacao;
      value = cotacao;
    }

    let total = priceHelper.priceToFloat(sourceAmount) * value;
    let iof = total * (iofPorcentage / 100);
    setIOF(iof);

    let totalWithTaxes = isProductSpeciesSell()
      ? total - parseFloat(iof.toFixed(2))
      : total + parseFloat(iof.toFixed(2));
    if (selectedProduct !== "remessa") {
      totalWithTaxes += tax;
    }

    if (totalWithTaxes > tax) {
      setTargetAmount(totalWithTaxes);
    }

    if (sourceAmount === "0,00") {
      setTargetAmount(0);
    }
  }

  function calcSourceAmount(newTargetValue) {
    setTargetAmount(newTargetValue);

    let {
      valor: value,
      iof: iofPorcentage,
      taxa: tax,
    } = currentQuotation[inverseProductSpeciesTypeLowerCase()];

    newTargetValue = priceHelper.priceToFloat(newTargetValue);
    if (selectedProduct !== "remessa") {
      newTargetValue -= tax;
    }

    let novaCotacao = value * (iofPorcentage / 100) + value;

    let totalSourceAmount = newTargetValue / novaCotacao;
    if (totalSourceAmount <= 0) totalSourceAmount = 0;

    let iof = totalSourceAmount * value * (iofPorcentage / 100);

    setIOF(iof);
    setSourceAmount(totalSourceAmount);
  }

  function cookieIsValid(cookie) {
    return typeof cookie !== "undefined";
  }

  const comprarDisabled =
    ("unavailable" in currentQuotation &&
      currentQuotation.unavailable === true) ||
    currentQuotation.isLoading ||
    priceHelper.priceToFloat(sourceAmount) === 0 ||
    priceHelper.priceToFloat(sourceAmount) === 0;

  function comprar() {
    let validacao = validaValoresComprar();
    if (validacao && window.parent.simuladorValidacaoFail) {
      window.parent.simuladorValidacaoFail(validacao);
      return;
    }

    if (window.parent.gtmAddToCart) {
      window.parent.gtmAddToCart({
        name: currentCurrency.nome,
        id: currentCurrency.id,
        price: currentQuotation.venda.valor,
        category: selectedProduct,
        quantity: priceHelper.priceToFloat(sourceAmount),
        brand: "confidence",
      });
    }

    const paramsEcommerce = {
      quantidade: priceHelper.priceToFloat(sourceAmount),
      moedaOperacionalId: currentCurrency.id_operacional,
    };

    if (selectedProduct === "especie") {
      const { nome, estado } = currentCity;

      paramsEcommerce.cidade = unorm.nfd(nome).replace(/[\u0300-\u036f]/g, "");
      paramsEcommerce.estado = estado;
    }

    if (selectedProduct === "remessa") {
      paramsEcommerce.paisId = currentCountry.id;
    }

    if (isProductSpeciesSell()) {
      paramsEcommerce.tipoOperacao = SpeciesType.BUY;
    }

    if (isProductSpeciesBuy()) {
      paramsEcommerce.tipoOperacao = SpeciesType.SELL;
    }

    const url = process.env.REACT_APP_ECOMMERCE_URL;
    window.parent.location.href = `${url}?sm=${btoa(
      JSON.stringify(paramsEcommerce)
    )}`;
  }

  function validaValoresComprar() {
    let { minimo_operavel, maximo_operavel, multiplicidade } =
      currentCurrency.validacoes;
    let floatSourceAmount = priceHelper.priceToFloat(sourceAmount);

    if (floatSourceAmount < minimo_operavel) {
      setSourceAmount(minimo_operavel);
      return `O valor mínimo permitido para essa operação é de ${
        currentCurrency.codigo_iso
      } ${priceHelper.formatPrice(minimo_operavel)}.`;
    }

    if (floatSourceAmount > maximo_operavel) {
      setSourceAmount(maximo_operavel);
      return `O valor máximo permitido para essa operação é de ${
        currentCurrency.codigo_iso
      } ${priceHelper.formatPrice(maximo_operavel)}.`;
    }

    multiplicidade = parseInt(multiplicidade);
    if (
      priceHelper.priceToFloat(sourceAmount) % multiplicidade !== 0 &&
      multiplicidade !== 0
    ) {
      let newVal =
        Math.ceil(floatSourceAmount / multiplicidade) * multiplicidade;
      setSourceAmount(newVal);
      return `A compra de moedas deve ser efetuada apenas por múltiplos de ${currentCurrency.codigo_iso} ${multiplicidade}. Por isso, arredondamos a quantia da sua operação.`;
    }

    return false;
  }

  useEffect(() => {
    window.addEventListener("message", onSimuladorProductClick);

    return () => {
      window.removeEventListener("message", onSimuladorProductClick);
    };
  }, [targetAmount, sourceAmount]);

  function onSimuladorProductClick(e) {
    if (e.origin !== window.location.origin) {
      return;
    }

    if (e.data === "simulador_produto_click") {
      if (
        currentQuotation.venda.valor !== undefined &&
        Math.ceil(currentQuotation.venda.valor) > 0
      ) {
        if (window.parent.gtmProductClick) {
          window.parent.gtmProductClick({
            name: currentCurrency.nome,
            id: currentCurrency.id,
            price: currentQuotation.venda.valor,
            brand: "confidence",
            category: selectedProduct,
          });
        }
      }
    }
  }

  const selectProductSpeciesBuy = () => {
    setProductSpeciesType(SpeciesType.BUY);
    if (window.parent.gtmProductClick) {
      window.parent.gtmProductClick({
        name: currentCurrency.nome,
        id: currentCurrency.id,
        price: currentQuotation.venda.valor,
        brand: "confidence",
        category: SpeciesType.BUY,
      });
    }
  };

  const selectProductSpeciesSell = () => {
    setProductSpeciesType(SpeciesType.SELL);
    if (window.parent.gtmProductClick) {
      window.parent.gtmProductClick({
        name: currentCurrency.nome,
        id: currentCurrency.id,
        price: currentQuotation.venda.valor,
        brand: "confidence",
        category: SpeciesType.SELL,
      });
    }
  };

  const isProductSpecies = () => selectedProduct === "especie";
  const isProductSpeciesBuy = () =>
    isProductSpecies() && productSpeciesType === SpeciesType.BUY;
  const isProductSpeciesSell = () =>
    isProductSpecies() && productSpeciesType === SpeciesType.SELL;

  const inverseProductSpeciesType = () =>
    isProductSpeciesSell() ? SpeciesType.BUY : SpeciesType.SELL;

  const inverseProductSpeciesTypeLowerCase = () =>
    isProductSpeciesSell()
      ? SpeciesType.BUY.toLocaleLowerCase()
      : SpeciesType.SELL.toLocaleLowerCase();

  if (!productSpeciesType) return;

  return (
    <div
      className={
        currentQuotation.isLoading
          ? "loading-page-block cotacao " + selectedProduct
          : "cotacao " + selectedProduct
      }
    >
      {currentQuotation.isLoading && (
        <div className="loading-spinner-simulador spinner-border"></div>
      )}

      {selectedProduct === "especie" && (
        <div className="simulator-species-buttons">
          <div
            onClick={selectProductSpeciesBuy}
            className={`simulator-species-buttons-left ${
              isProductSpeciesBuy()
                ? "simulator-species-buttons-left-active"
                : ""
            }`}
          >
            Quero Comprar Moeda
          </div>
          <div
            onClick={selectProductSpeciesSell}
            className={`simulator-species-buttons-right ${
              isProductSpeciesSell()
                ? "simulator-species-buttons-right-active"
                : ""
            }`}
          >
            Quero Vender Moeda
          </div>
        </div>
      )}

      <CitySelector
        isOpen={citySeletor}
        onClose={(val) => setCitySeletor(val)}
        onSelect={(val) => setCurrentCity(val)}
      />

      <div>
        <div className="wrapSimulator">
          {selectedProduct === "remessa" && (
            <div>
              <span className="label">País que deseja transferir</span>

              <CurrencyBox
                items={countries}
                showSelectedOptionText={true}
                selectedItem={currentCountry}
                onDropDownChange={(val) => setCurrentCountry(val)}
                searchPlaceholder="Digite o país"
              />
            </div>
          )}
          {trocarOrdem ? (
            <>
              <span className="label value">
                {isProductSpeciesBuy() && "Você compra"}
                {isProductSpeciesSell() && "Você vende"}
                {selectedProduct === "remessa" && "Você envia*"}
                {selectedProduct === "cartao" && "Você carrega"}
              </span>
              <div className="flex">
                <CurrencyBox
                  items={currencies}
                  value={sourceAmount}
                  selectedItem={currentCurrency}
                  onDropDownChange={(val) => setCurrentCurrency(val)}
                  onInputChange={(val) => setSourceAmount(val)}
                  searchPlaceholder="Digite a moeda"
                />
                <img
                  src={svgTrocaOrdem}
                  alt="trocar"
                  className="iconeTrocarOrdem"
                  onClick={() => setTrocarOrdem(!trocarOrdem)}
                />
              </div>
              <span className="label value">
                {isProductSpeciesBuy() && "Você paga"}
                {isProductSpeciesSell() && "Você recebe"}
                {selectedProduct === "remessa" && "Você paga"}
                {selectedProduct === "cartao" && "Você paga"}
              </span>
              <CurrencyBox
                items={defaultCurrency}
                value={targetAmount}
                onInputChange={(val) => calcSourceAmount(val)}
                defaultCurrency={true}
              />
            </>
          ) : (
            <>
              <span className="label value">
                {isProductSpeciesBuy() && "Você paga"}
                {isProductSpeciesSell() && "Você recebe"}
                {selectedProduct === "remessa" && "Você paga"}
                {selectedProduct === "cartao" && "Você paga"}
              </span>

              <div className="flex">
                <CurrencyBox
                  items={defaultCurrency}
                  value={targetAmount}
                  onInputChange={(val) => calcSourceAmount(val)}
                  defaultCurrency={true}
                />
                <img
                  src={svgTrocaOrdem}
                  alt="trocar"
                  className="iconeTrocarOrdem"
                  onClick={() => setTrocarOrdem(!trocarOrdem)}
                />
              </div>

              <span className="label value">
                {isProductSpeciesBuy() && "Você compra"}
                {isProductSpeciesSell() && "Você vende"}
                {selectedProduct === "remessa" && "Você envia*"}
                {selectedProduct === "cartao" && "Você carrega"}
              </span>

              <CurrencyBox
                items={currencies}
                value={sourceAmount}
                selectedItem={currentCurrency}
                onDropDownChange={(val) => setCurrentCurrency(val)}
                onInputChange={(val) => setSourceAmount(val)}
                searchPlaceholder="Digite a moeda"
              />
            </>
          )}

          <div className="wrap-taxas">
            <a
              href={"/"}
              onClick={(event) => {
                event.preventDefault();
                setShowHideTax(!showHideTax);
              }}
              className="showHideTaxas"
            >
              <img
                src={showHideTax ? svgHideTax : svgShowTax}
                alt="Mostar ou esconder taxas"
                className="iconTax"
              />{" "}
              {showHideTax ? "Esconder taxas" : "Exibir taxas"}
            </a>
            {showHideTax && (
              <ul className="taxas">
                <li className="conteudo">
                  <span className="multiplication">
                    <ul className="box-flex">
                      <li className="title-taxa">Câmbio comercial</li>
                      <li>
                        R${" "}
                        {priceHelper.formatPrice(
                          currentQuotation[inverseProductSpeciesTypeLowerCase()]
                            .valor,
                          true
                        )}
                      </li>
                    </ul>
                  </span>
                  <span className="addition">
                    <ul className="box-flex">
                      <li className="title-taxa">
                        IOF (
                        R$ {priceHelper.formatPrice(
                          currentQuotation[inverseProductSpeciesTypeLowerCase()]
                            .iof
                        )}
                        %)
                      </li>
                      <li>
                      R$ {defaultCurrency.simbolo} {priceHelper.formatPrice(IOF)}
                      </li>
                    </ul>
                  </span>
                  {!isProductSpeciesSell() && (
                    <span className="addition">
                      <ul className="box-flex">
                        <li className="title-taxa">Taxa administrativa</li>
                        <li>
                          {selectedProduct === "remessa" ? (
                            <s>
                              {defaultCurrency.simbolo}{" "}
                              R$ {priceHelper.formatPrice(
                                currentQuotation[
                                  inverseProductSpeciesTypeLowerCase()
                                ].taxa
                              )}
                            </s>
                          ) : (
                            <div className="inline">
                              {defaultCurrency.simbolo}{" "}
                              R$ {priceHelper.formatPrice(
                                currentQuotation[
                                  inverseProductSpeciesTypeLowerCase()
                                ].taxa
                              )}
                            </div>
                          )}
                        </li>
                      </ul>
                    </span>
                  )}

                  <span className="division">
                    <ul className="box-flex">
                      <li className="title-taxa">Valor da compra</li>
                      <li>
                        {defaultCurrency.simbolo}{" "}
                        R$ {priceHelper.formatPrice(targetAmount)}
                      </li>
                    </ul>
                  </span>

                  <span className="equal">
                    <ul className="box-flex">
                      <li className="title-taxa">
                        <b>Câmbio final (VET)</b>
                      </li>
                      <li>
                      R$ {(parseFloat(targetAmount) / parseFloat(sourceAmount))
                          .toFixed(6)
                          .toString()
                          .replace(".", ",")}
                      </li>
                    </ul>
                  </span>
                </li>
                <li
                  className="linkInfoTaxas"
                  onClick={() => setShowModalTaxas(true)}
                >
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyBpZD0iaW5mby1jaXJjbGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogIDxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMy4zMzMsMjYuNjY3QTEzLjMzMywxMy4zMzMsMCwxLDAsMCwxMy4zMzMsMTMuMzczLDEzLjM3MywwLDAsMCwxMy4zMzMsMjYuNjY3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi42NjcgMi42NjcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICA8cGF0aCBpZD0iVmVjdG9yLTIiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwVjYuNjY3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiAxMC42NjcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICA8cGF0aCBpZD0iVmVjdG9yLTMiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwSC4wMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ljk5MyAyMS4zMzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGE2ZGEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPHBhdGggaWQ9IlZlY3Rvci00IiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMEgzMlYzMkgwWiIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iMCIvPgo8L3N2Zz4K"
                    alt="Informações"
                  />
                </li>
              </ul>
            )}
          </div>

          {showModalTaxas && (
            <div className="wrap-modal-new">
              <div className="modal-new">
                <p>
                  <strong>Câmbio comercial</strong>
                  <br />É a cotação do dólar comercial no momento da transação
                  sem taxas ou tarifas.
                </p>
                <p>
                  <strong>IOF</strong>
                  <br />É o Imposto sobre Operações Financeiras cobrado sobre
                  operações de câmbio.
                </p>
                <p>
                  <strong>Taxa de Serviço </strong>
                  <br />
                  São os custos operacionais da transação.
                </p>
                <p>
                  <strong>VET (Valor Efetivo Total) </strong>
                  <br />É o valor da compra X taxa câmbio, acrescido de IOF +
                  Tarifas, dividido pelo valor da compra.
                </p>
                <button className="buttonModalTaxas" onClick={() => setShowModalTaxas(false)}>Entendi</button>
              </div>
            </div>
          )}
        </div>
        {selectedProduct === "especie" && (
          <div className="text-center block-city">
            <span className="gray ">
              Cotação:&nbsp;
              <span
                className="estado lightBlue"
                onClick={() => setCitySeletor(!citySeletor)}
              >
                {currentCity && currentCity.nome}
              </span>
            </span>
          </div>
        )}

        <div className="text-center">
          <button
            type="button"
            className="button"
            onClick={comprar}
            disabled={comprarDisabled}
          >
            {selectedProduct === "remessa"
              ? "ENVIAR DINHEIRO"
              : isProductSpeciesSell()
              ? "VENDER ONLINE"
              : "COMPRAR ONLINE"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default memo(Main);
